import React, { useState, useEffect } from 'react';
import playersData from './NBAMEGA.json';
import styles from './generator.module.css';
import { Link, useLocation } from "react-router-dom";
import sports from "../../sports";
import crossover_logo from "../../assets/nba.svg";
import crossover_brand_logo from "../../assets/crossover_games_icon.png";
import PageInfo from "../PageInfo/PageInfo";

const TEAM_LOGOS = {
    ATL: "https://loodibee.com/wp-content/uploads/nba-atlanta-hawks-logo.png",
    BOS: "https://loodibee.com/wp-content/uploads/nba-boston-celtics-logo.png",
    BRK: "https://loodibee.com/wp-content/uploads/nba-brooklyn-nets-logo.png",
    CHA: "https://loodibee.com/wp-content/uploads/nba-charlotte-hornets-logo.png",
    CHI: "https://loodibee.com/wp-content/uploads/nba-chicago-bulls-logo.png",
    CLE: "https://loodibee.com/wp-content/uploads/nba-cleveland-cavaliers-logo.png",
    DAL: "https://loodibee.com/wp-content/uploads/nba-dallas-mavericks-logo.png",
    DEN: "https://loodibee.com/wp-content/uploads/nba-denver-nuggets-logo-2018.png",
    DET: "https://loodibee.com/wp-content/uploads/nba-detroit-pistons-logo.png",
    GSW: "https://loodibee.com/wp-content/uploads/nba-golden-state-warriors-logo.png",
    HOU: "https://loodibee.com/wp-content/uploads/nba-houston-rockets-logo.png",
    IND: "https://loodibee.com/wp-content/uploads/nba-indiana-pacers-logo.png",
    LAC: "https://loodibee.com/wp-content/uploads/NBA-LA-Clippers-logo-2024-480x480.png",
    LAL: "https://loodibee.com/wp-content/uploads/nba-los-angeles-lakers-logo.png",
    MEM: "https://loodibee.com/wp-content/uploads/nba-memphis-grizzlies-logo.png",
    MIA: "https://loodibee.com/wp-content/uploads/nba-miami-heat-logo.png",
    MIL: "https://loodibee.com/wp-content/uploads/nba-milwaukee-bucks-logo.png",
    MIN: "https://loodibee.com/wp-content/uploads/nba-minnesota-timberwolves-logo.png",
    NOP: "https://loodibee.com/wp-content/uploads/nba-new-orleans-pelicans-logo.png",
    NYK: "https://loodibee.com/wp-content/uploads/nba-new-york-knicks-logo.png",
    OKC: "https://loodibee.com/wp-content/uploads/nba-oklahoma-city-thunder-logo.png",
    ORL: "https://loodibee.com/wp-content/uploads/nba-orlando-magic-logo.png",
    PHI: "https://loodibee.com/wp-content/uploads/nba-philadelphia-76ers-logo.png",
    PHO: "https://loodibee.com/wp-content/uploads/nba-phoenix-suns-logo.png",
    POR: "https://loodibee.com/wp-content/uploads/nba-portland-trail-blazers-logo.png",
    SAC: "https://loodibee.com/wp-content/uploads/nba-sacramento-kings-logo.png",
    SAS: "https://loodibee.com/wp-content/uploads/nba-san-antonio-spurs-logo.png",
    TOR: "https://loodibee.com/wp-content/uploads/nba-toronto-raptors-logo.png",
    UTA: "https://loodibee.com/wp-content/uploads/nba-utah-jazz-logo.png",
    WAS: "https://loodibee.com/wp-content/uploads/nba-washington-wizards-logo.png",
    SEA: "https://loodibee.com/wp-content/uploads/seattle-supersonics-logo.png",
    NJN: "https://loodibee.com/wp-content/uploads/new-jersey-nets-logo-old.png",
    NOH: "https://loodibee.com/wp-content/uploads/nba-new-orleans-pelicans-logo.png",
    VAN: "https://loodibee.com/wp-content/uploads/vancouver-grizzlies-logo.png",
};

const POSITIONS = ["G", "F", "C"];

function RandomPlayerGenerator() {
    const location = useLocation();
    const [page_name] = useState("");
    const [activeStatus, setActiveStatus] = useState('all');
    const [generatedPlayers, setGeneratedPlayers] = useState([]);
    const [numberOfPlayers, setNumberOfPlayers] = useState('');
    const [teams, setTeams] = useState([]);
    const [selectedTeams, setSelectedTeams] = useState(new Set());
    const [selectedPositions, setSelectedPositions] = useState(new Set());
    const [isGenerated, setIsGenerated] = useState(false);
    const [showAdvancedFilters, setShowAdvancedFilters] = useState(false);

    useEffect(() => {
        setTeams(Object.keys(TEAM_LOGOS));
    }, []);

    const toggleTeam = (team, event) => {
        event.stopPropagation();
        const newSet = new Set(selectedTeams);
        if (newSet.has(team)) newSet.delete(team);
        else newSet.add(team);
        setSelectedTeams(newSet);
    };

    const togglePosition = (position, event) => {
        event.stopPropagation();
        const newSet = new Set(selectedPositions);
        if (newSet.has(position)) newSet.delete(position);
        else newSet.add(position);
        setSelectedPositions(newSet);
    };

    const shuffleArray = (array) => {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const selectedTeamsArray = Array.from(selectedTeams);
        const selectedPositionsArray = Array.from(selectedPositions);
        const numPlayers = parseInt(numberOfPlayers, 10) || playersData.length;

        let filtered = playersData.filter(player => {
            const matchesTeam =
                selectedTeamsArray.length === 0 ||
                (Array.isArray(player.Team)
                    ? selectedTeamsArray.some(t => player.Team.includes(t))
                    : selectedTeamsArray.includes(player.Team));
            const matchesPos =
                selectedPositionsArray.length === 0 ||
                (Array.isArray(player.Pos)
                    ? selectedPositionsArray.some(p => player.Pos.includes(p))
                    : selectedPositionsArray.includes(player.Pos));
            const matchesActive =
                activeStatus === 'all' ||
                (activeStatus === 'active' && player.Active === 'Yes') ||
                (activeStatus === 'inactive' && player.Active !== 'Yes');
            return matchesTeam && matchesPos && matchesActive;
        });

        if (filtered.length > 0) {
            filtered = shuffleArray(filtered);
            setGeneratedPlayers(filtered.slice(0, numPlayers));
            setIsGenerated(true);
        } else {
            setGeneratedPlayers([]);
            setIsGenerated(false);
        }
    };

    return (
        <>
            <div className={styles.container}>
                <nav className="navbar">
                    <a href="https://crossovergrid.com" className={styles.navLink}>
                        <img src={crossover_logo} alt="Logo" className="navbar-logo" />
                        <p className={styles.navTitle}>CROSSOVER GRID NBA</p>
                    </a>
                </nav>

                <div className="sport-picker">
                    <div className="links">
                        {sports.map((sport) => (
                            <Link
                                key={sport.id}
                                className={`sportLink ${page_name === sport.id ? "selected" : ""}`}
                                to={sport.path}
                            >
                                {sport.emoji.startsWith("http")
                                    ? <img src={sport.emoji} alt={sport.name} />
                                    : <span>{sport.emoji}</span>}
                                <br />
                                {sport.name.length < 4
                                    ? <span>{sport.name}</span>
                                    : <span style={{ fontSize: 12 }}>{sport.name}</span>}
                            </Link>
                        ))}
                    </div>
                </div>

                <div className={styles.body}>
                    <h2 className={styles.title}>Random NBA Player Generator</h2>

                    <form className={styles.form} onSubmit={handleSubmit}>
                        <div className={styles.field}>
                            <label className={styles.fieldLabel}>Number of Players</label>
                            <input
                                type="number"
                                min="1"
                                value={numberOfPlayers}
                                onChange={e => setNumberOfPlayers(e.target.value)}
                                className={styles.input}
                                required
                            />
                        </div>

                        <div className={styles.field}>
                            <label className={styles.fieldLabel}>Status</label>
                            <div className={styles.segmented}>
                                {[
                                    ['all', 'All'],
                                    ['active', 'Active'],
                                    ['inactive', 'Inactive'],
                                ].map(([val, label]) => (
                                    <label
                                        key={val}
                                        className={`${styles.segment} ${activeStatus === val ? styles.segmentActive : ''}`}
                                    >
                                        <input
                                            type="radio"
                                            name="active-status"
                                            value={val}
                                            checked={activeStatus === val}
                                            onChange={(e) => setActiveStatus(e.target.value)}
                                        />
                                        {label}
                                    </label>
                                ))}
                            </div>
                        </div>

                        <button
                            type="button"
                            onClick={() => setShowAdvancedFilters(!showAdvancedFilters)}
                            className={styles.btnGhost}
                        >
                            {showAdvancedFilters ? 'Hide' : 'Show'} Advanced Filters
                        </button>

                        {showAdvancedFilters && (
                            <div className={styles.advanced}>
                                <div className={styles.field}>
                                    <label className={styles.fieldLabel}>Teams</label>
                                    <div className={styles.filterRow}>
                                        {teams.map((team) => (
                                            <button
                                                type="button"
                                                key={`team-${team}`}
                                                onClick={(e) => toggleTeam(team, e)}
                                                className={`${styles.filterButton} ${selectedTeams.has(team) ? styles.filterButtonSelected : ''}`}
                                            >
                                                <img src={TEAM_LOGOS[team]} alt={team} className={styles.teamLogo} />
                                                {team}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                                <div className={styles.field}>
                                    <label className={styles.fieldLabel}>Positions</label>
                                    <div className={styles.filterRow}>
                                        {POSITIONS.map((position) => (
                                            <button
                                                type="button"
                                                key={`pos-${position}`}
                                                onClick={(e) => togglePosition(position, e)}
                                                className={`${styles.filterButton} ${selectedPositions.has(position) ? styles.filterButtonSelected : ''}`}
                                            >
                                                {position}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        )}

                        <button type="submit" className={styles.btnPrimary}>Generate</button>
                    </form>

                    {isGenerated && generatedPlayers.length > 0 && (
                        <div className={styles.results}>
                            <h3>Generated Players</h3>
                            <a
                                href="https://crossover.games"
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.presentedBy}
                            >
                                <span className={styles.presentedByLabel}>Presented by</span>
                                <img src={crossover_brand_logo} alt="Crossover Games" className={styles.presentedByLogo} />
                                <span className={styles.presentedByName}>Crossover.Games</span>
                            </a>
                            <ul className={styles.resultsList}>
                                {generatedPlayers.map((player, index) => {
                                    const imageUrl = player["Image Url"] || 'https://via.placeholder.com/150?text=No+Image';
                                    const uniqueKey = `nba-player-${index}`;
                                    const teamArr = (Array.isArray(player.Team) ? player.Team : [player.Team]).filter(Boolean);
                                    return (
                                        <li key={uniqueKey} className={styles.resultItem}>
                                            <div className={styles.playerImageWrapper}>
                                                <img
                                                    src={imageUrl}
                                                    alt={`${player.Player}'s profile`}
                                                    className={styles.playerImage}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src = 'https://via.placeholder.com/150?text=No+Image';
                                                    }}
                                                />
                                            </div>
                                            <div className={styles.playerInfo}>
                                                <h3 className={styles.playerName}>{player.Player}</h3>
                                                <div className={styles.playerDetails}>
                                                    <div className={styles.detailRow}>
                                                        <span className={styles.detailLabel}>Position</span>
                                                        <span className={styles.detailValue}>
                                                            {Array.isArray(player.Pos) ? player.Pos.join(', ') : player.Pos || '—'}
                                                        </span>
                                                    </div>
                                                    <div className={styles.detailRow}>
                                                        <span className={styles.detailLabel}>Teams</span>
                                                        <span className={styles.detailValue}>
                                                            <span className={styles.teamLogosContainer}>
                                                                {teamArr.length === 0 && <span>—</span>}
                                                                {teamArr.map((team, idx) => {
                                                                    const teamKey = `${uniqueKey}-team-${idx}-${team}`;
                                                                    return TEAM_LOGOS[team] ? (
                                                                        <img
                                                                            key={teamKey}
                                                                            src={TEAM_LOGOS[team]}
                                                                            alt={team}
                                                                            className={styles.teamLogoSmall}
                                                                            title={team}
                                                                        />
                                                                    ) : (
                                                                        <span key={teamKey} className={styles.teamText}>{team}</span>
                                                                    );
                                                                })}
                                                            </span>
                                                        </span>
                                                    </div>
                                                    {(player.From || player.To) && (
                                                        <div className={styles.detailRow}>
                                                            <span className={styles.detailLabel}>Career</span>
                                                            <span className={styles.detailValue}>
                                                                {(() => {
                                                                    const startYear = String(player.From || '').slice(0, 4);
                                                                    const endSeason = String(player.To || '');
                                                                    const m = endSeason.match(/(\d{4})-(\d{2})/);
                                                                    const endYear = m ? `${m[1].slice(0,2)}${m[2]}` : (endSeason.slice(0, 4) || 'present');
                                                                    return startYear ? `${startYear}-${endYear}` : endYear;
                                                                })()}
                                                            </span>
                                                        </div>
                                                    )}
                                                    <div className={styles.detailRow}>
                                                        <span className={styles.detailLabel}>Games</span>
                                                        <span className={styles.detailValue}>{player.G || '—'}</span>
                                                    </div>
                                                    {(player.Height || player.Weight) && (
                                                        <div className={styles.detailRow}>
                                                            <span className={styles.detailLabel}>Size</span>
                                                            <span className={styles.detailValue}>
                                                                {[player.Height, player.Weight ? `${player.Weight} lbs` : null].filter(Boolean).join(' · ')}
                                                            </span>
                                                        </div>
                                                    )}
                                                    {(player.DrftYr || player.Round || player.Pick) && (
                                                        <div className={styles.detailRow}>
                                                            <span className={styles.detailLabel}>Draft</span>
                                                            <span className={styles.detailValue}>
                                                                {player.DrftYr || '—'}
                                                                {player.Round && player.Pick ? ` · Rd ${player.Round}, Pk ${player.Pick}` : (player.Round ? ` · Rd ${player.Round}` : '')}
                                                            </span>
                                                        </div>
                                                    )}
                                                    {player.College && (
                                                        <div className={styles.detailRow}>
                                                            <span className={styles.detailLabel}>College</span>
                                                            <span className={styles.detailValue}>{player.College}</span>
                                                        </div>
                                                    )}
                                                    {player.Country && (
                                                        <div className={styles.detailRow}>
                                                            <span className={styles.detailLabel}>Country</span>
                                                            <span className={styles.detailValue}>{player.Country}</span>
                                                        </div>
                                                    )}
                                                    <div className={styles.detailRow}>
                                                        <span className={styles.detailLabel}>Status</span>
                                                        <span className={`${styles.statusPill} ${player.Active === 'Yes' ? styles.statusActive : styles.statusInactive}`}>
                                                            {player.Active === 'Yes' ? 'Active' : 'Inactive'}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    )}

                    {isGenerated && generatedPlayers.length === 0 && (
                        <p className={styles.emptyState}>No players matched these filters.</p>
                    )}
                </div>
            </div>
            <PageInfo
                title="Random NBA Player Generator - Discover NBA Players"
                metaTitle="Random NBA Player Generator - Discover NBA Players"
                metaDescription="Generate random NBA players and discover interesting stats, teams, and career information. Perfect for trivia, research, or just exploring NBA history!"
                metaUrl={location.pathname}
                keywords={["nba player generator", "random nba player", "nba players", "nba stats", "basketball players", "nba trivia"]}
                twitterCreator="@CrossoverGrid"
            />
        </>
    );
}

export default RandomPlayerGenerator;
